import React, { useEffect } from 'react';

import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import FieldSelect from '../commons/FieldSelect';
import FieldText from '../commons/FieldText';
import FieldNumber from '../commons/FieldNumber';

import { fetchPostalCodeData } from '../../store/catalogs-actions';
import { catalogsActions } from '../../store/catalogs-slice';
import { form4Actions } from '../../store/forms/form4-slice';
import { form5Actions } from '../../store/forms/form5-slice';

const Address = ({ isInsuredPerson }) => {
  const {
    setFieldValue,
    setFieldError,
  } = useFormikContext();

  const dispatch = useDispatch();
  const token = useSelector((state) => state.appConfig.appToken);
  const colonies = useSelector((state) => state.catalogs.colonies);
  const postalCode = useSelector((state) => state.landingPage.postalCode);

  const setStateAndMunicipality = (state, municipality) => {
    setFieldValue('state', state ? state.nombre : '');
    setFieldValue('municipality', municipality ? municipality.nombre : '');
    if (isInsuredPerson) {
      dispatch(form4Actions.setStateAndMunicipality({ state, municipality }));
    } else {
      dispatch(form5Actions.setStateAndMunicipality({ state, municipality }));
    }
  };

  const clearAddress = () => {
    setFieldValue('state', '');
    setFieldValue('municipality', '');
    setFieldValue('colony', '');
    if (isInsuredPerson) {
      dispatch(form4Actions.setStateAndMunicipality({ state: {}, municipality: {} }));
    } else {
      dispatch(form5Actions.setStateAndMunicipality({ state: {}, municipality: {} }));
    }
  };

  const setErrorPostalCode = (message) => {
    setTimeout(() => setFieldError('postalCode', message), 10);
    clearAddress();
  };

  const onChangePostalCode = (value) => {
    if (value.length >= 5) {
      dispatch(fetchPostalCodeData(
        token,
        value,
        setStateAndMunicipality,
        setErrorPostalCode,
      ));
    } else {
      clearAddress();
      dispatch(catalogsActions.setColonies({ colonies: [] }));
    }
  };

  useEffect(() => {
    if (isInsuredPerson && postalCode && token) {
      setFieldValue('postalCode', postalCode);
      dispatch(fetchPostalCodeData(
        token,
        postalCode,
        setStateAndMunicipality,
        setErrorPostalCode,
      ));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInsuredPerson, postalCode, token]);

  return (
    <>
      <h3>Dirección</h3>
      <hr className="solid" />
      {/* POSTAL CODE && STATE */}
      <div className="field-row">
        <FieldNumber
          label="Código postal"
          name="postalCode"
          maxLength={5}
          disabled={isInsuredPerson}
          onChangeCallback={onChangePostalCode}
          required />
        <FieldText label="Estado:" required name="state" disabled />
      </div>

      <div className="field-row">
        {/* MUNICIPALITY && COLONY */}
        <FieldText
          disabled
          label="Municipio"
          required
          name="municipality" />
        <FieldSelect
          label="Colonia:"
          required
          keyLabel="colonia"
          keyName="colonia"
          list={colonies}
          name="colony" />
      </div>
      <div className="field-row">
        {/* STREET && NUM EXT && NUM INT */}
        <FieldText label="Calle" name="street" placeHolder="Calle" required />
        <div className="field -double-input">
          <FieldText
            label="Número ext"
            name="noExt"
            placeHolder="número"
            required
            className="field -input -half" />
          <FieldText
            label="Número int"
            name="noInt"
            placeHolder="número"
            required={false}
            className="field -input -half" />
        </div>
      </div>
    </>
  );
};

Address.propTypes = {
  isInsuredPerson: PropTypes.bool.isRequired,
};

export default Address;
